import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(client)/capa/(pages)/(detail)')({
  component: DetailLayout,
});

function DetailLayout() {
  return (
    <div className='h-[calc(100vh-58px)] overflow-y-auto'>
      <Outlet />
    </div>
  );
}
